<ion-card color="light" class="my-item ion-no-margin">
  <ion-grid *ngIf="selectOrder" class="ion-no-padding">
    <ion-row class="ion-padding-horizontal parent-class">
      <ion-col>
        <ion-row
          [ngClass]="{ 'status-area': selectOrder?.status !== 'CANCELLED' }"
        >
          <ion-col size="12" class="ion-no-padding">
            <ion-text color="medium" class="label">status</ion-text>
          </ion-col>
          <ion-col size="12" class="ion-no-padding" class="status-icons">
            <ion-icon
              [src]="'./assets/SALE_CREATED.svg'"
              *ngIf="
                selectOrder?.saleOrder && selectOrder?.status === 'CREATED'
              "
            ></ion-icon>
            <ion-icon
              [src]="'./assets/MATERIAL_RECEIVED.svg'"
              *ngIf="
                selectOrder?.saleOrder &&
                selectOrder?.status === 'PICKUP_SCHEDULED'
              "
            ></ion-icon>
            <ion-icon
              [src]="'./assets/REJECTED.svg'"
              *ngIf="
                selectOrder?.payment?.orderPaymentStatus ===
                  'INVOICE_REJECTED' &&
                selectOrder?.status === 'ORDER_COMPLETED'
              "
            ></ion-icon>
            <ion-icon
              [src]="'./assets/INVOICE_PENDING.svg'"
              *ngIf="
                selectOrder?.payment?.orderPaymentStatus ===
                  'INVOICE_VERIFICATION_PENDING' &&
                selectOrder?.status === 'ORDER_COMPLETED'
              "
            ></ion-icon>
            <ion-icon
              [src]="'./assets/' + selectOrder?.status + '.svg'"
              [ngClass]="{ 'reject-icon': selectOrder?.status === 'CANCELLED' }"
              *ngIf="
                !selectOrder?.saleOrder &&
                selectOrder?.status !== 'ORDER_COMPLETED' &&
                selectOrder?.status != 'HOLD' &&
                selectOrder?.status != 'AWAITING_PICKUP_CONFIRMATION'
              "
            ></ion-icon>
            <ion-icon
              [src]="
                './assets/' + selectOrder?.payment?.orderPaymentStatus + '.svg'
              "
              *ngIf="
                selectOrder?.payment?.orderPaymentStatus !==
                  'INVOICE_REJECTED' &&
                selectOrder?.status === 'ORDER_COMPLETED' &&
                selectOrder?.payment?.orderPaymentStatus !==
                  'INVOICE_VERIFICATION_PENDING'
              "
            ></ion-icon>
            <ion-text
              class="status"
              color="dark"
              *ngIf="
                selectOrder?.status !== 'ORDER_COMPLETED' &&
                selectOrder?.status !== 'AWAITING_PICKUP_CONFIRMATION'
              "
              >{{ selectOrder?.displayStatusTitle }}</ion-text
            >
            <ion-text
              class="status"
              color="dark"
              *ngIf="
                selectOrder?.status !== 'ORDER_COMPLETED' &&
                selectOrder?.status === 'AWAITING_PICKUP_CONFIRMATION'
              "
              >{{ selectOrder?.statusTitle }}</ion-text
            >
            <ion-text
              class="status ion-text-capitalize"
              color="dark"
              *ngIf="selectOrder?.status === 'ORDER_COMPLETED'"
              >{{
                selectOrder.saleOrder
                  ? selectOrder?.displayStatusTitle
                  : selectOrder?.payment?.statusTitle
              }}
            </ion-text>
          </ion-col>
        </ion-row>
        <ion-row margin-top *ngIf="status(['CANCELLED', 'REJECTED'], false)">
          <!--   Quick Actions   -->
          <ion-col
            size="12"
            class="ion-no-padding quick-actions"
            *ngIf="
              !(
                status(['CANCELLED', 'REJECTED'], true) ||
                ['COMPLETED', 'INVOICE_REJECTED'].indexOf(
                  selectOrder?.payment?.orderPaymentStatus
                ) >= 0
              )
            "
          >
            <ion-text color="medium" class="label">Quick Actions</ion-text>
            <div>
              <!-- CHANGE TIMELSOT BUTTON -->
              <rcyl-timeslot-button
                [order]="selectOrder"
                *ngIf="
                  selectOrder?.orderType != 'DROP' &&
                  status(
                    ['VERIFIED', 'CREATED', 'PICKUP_SCHEDULED', 'HOLD'],
                    true
                  )
                "
                (changeTimeSlot)="loadTimeSlot($event)"
              >
              </rcyl-timeslot-button>

              <rcyl-cancel-order-button
                *ngIf="
                  !selectOrder?.saleOrder &&
                  status(
                    [
                      'ORDER_COMPLETED',
                      'HOLD',
                      'CANCELLED',
                      'MATERIAL_RECEIVED',
                      'MATERIAL_PICKED'
                    ],
                    false
                  )
                "
                [config]="getConfig"
                [buttonTriggered]="'HOLD'"
                [orderType]="selectOrder?.orderType"
                [orderId]="selectOrder.id"
                (getResult)="openHoldDialog($event)"
              >
              </rcyl-cancel-order-button>

              <rcyl-cancel-order-button
                *ngIf="
                  !selectOrder?.saleOrder &&
                  status(
                    ['CREATED', 'HOLD', 'PICKUP_SCHEDULED', 'VERIFIED'],
                    true
                  )
                "
                [config]="getConfig"
                [buttonTriggered]="'REJECT'"
                [orderType]="selectOrder?.orderType"
                [orderId]="selectOrder.id"
                (getResult)="openCancelDialog($event)"
              >
              </rcyl-cancel-order-button>
              <ion-button
                *ngIf="
                  !selectOrder?.saleOrder &&
                  selectOrder?.orderType !== 'DROP' &&
                  status(
                    ['PICKUP_SCHEDULED', 'AWAITING_PICKUP_CONFIRMATION'],
                    true
                  )
                "
                (click)="pickedOrderAlert()"
                [color]="'primary'"
                class="ion-text-uppercase"
              >
                <ion-icon
                  name="checkmark"
                  class="ion-float-left icon-padding"
                  color="light"
                ></ion-icon>
                MARK AS PICKED
              </ion-button>
              <ion-button
                *ngIf="
                  (selectOrder?.orderType === 'DROP' &&
                    status(['PICKUP_SCHEDULED'], true)) ||
                  (selectOrder?.orderType === 'PICKUP' &&
                    status(['MATERIAL_PICKED'], true))
                "
                (click)="markDeliveredOrReceived()"
                [color]="'primary'"
                class="ion-text-uppercase"
              >
                <ion-icon
                  name="checkmark"
                  class="ion-float-left icon-padding"
                  color="light"
                ></ion-icon>
                {{
                  selectOrder?.saleOrder
                    ? "Mark as Delivered"
                    : "Mark as Received"
                }}
              </ion-button>
              <ion-button
                *ngIf="selectOrder?.saleOrder && status(['CREATED'], true)"
                (click)="dispatch()"
                [color]="'primary'"
                class="ion-text-uppercase"
              >
                <ion-icon
                  name="checkmark"
                  class="ion-float-left icon-padding"
                  color="light"
                ></ion-icon>
                Mark as Dispatched</ion-button
              >
              <ion-button
                *ngIf="
                  !selectOrder?.saleOrder && status(['MATERIAL_RECEIVED'], true)
                "
                (click)="completeOrderAlert($event)"
                [color]="'primary'"
                class="ion-text-uppercase complete-btn"
              >
                <ion-icon
                  name="checkmark"
                  class="ion-float-left icon-padding"
                  color="light"
                ></ion-icon>
                Complete Order
              </ion-button>
              <ion-button
                *ngIf="
                  !selectOrder?.saleOrder && status(['CREATED', 'HOLD'], true)
                "
                (click)="selectPickupExecutive()"
                class="ion-text-uppercase"
              >
                <ion-icon
                  name="checkmark"
                  class="ion-float-left icon-padding"
                  color="light"
                ></ion-icon>
                Assign Executive
              </ion-button>

              <rcyl-verify-invoice-button
                *ngIf="
                  selectOrder?.payment?.orderPaymentStatus ===
                  'INVOICE_VERIFICATION_PENDING'
                "
                [id]="selectOrder?.id"
                [formattedId]="selectOrder?.formattedId"
                (verifiedStatus)="verifyInvoice($event)"
              ></rcyl-verify-invoice-button>

              <rcyl-make-payment-button
                *ngIf="
                  status(['MATERIAL_RECEIVED'], true) ||
                  selectOrder?.payment?.orderPaymentStatus ===
                    'INVOICE_PENDING' ||
                  selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING'
                "
                [selectOrder]="selectOrder?.id"
                [order]="selectOrder"
                [tradeType]="selectOrder?.tradeType"
                (paymentStatus)="makePayment($event)"
              >
              </rcyl-make-payment-button>
            </div>
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-col
        size="7"
        *ngIf="
          selectOrder?.status === 'MATERIAL_RECEIVED' ||
          selectOrder?.payment?.orderPaymentStatus ===
            'INVOICE_VERIFICATION_PENDING' ||
          selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING' ||
          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_PENDING'
        "
      >
        <ng-container *ngTemplateOutlet="received_at"></ng-container>
      </ion-col>

      <!--      invoice rejection reason-->
      <ion-col
        size="12"
        *ngIf="
          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_REJECTED' &&
          invoiceRejectedObj?.status === 'INVOICE_REJECTED'
        "
      >
        <ng-container *ngTemplateOutlet="rejection_reason"></ng-container>
      </ion-col>

      <!--Cancellation or On-hold reason-->
      <ion-col size="12" *ngIf="status(['CANCELLED', 'REJECTED'], true)">
        <ng-container *ngTemplateOutlet="OnHold_Reject"></ng-container>
      </ion-col>

      <ion-col size="7" *ngIf="status(['HOLD'], true)">
        <ng-container *ngTemplateOutlet="OnHold_Reject"></ng-container>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-card>

<ng-template #rejection_reason>
  <ion-grid>
    <ion-row>
      <ion-col size="12" class="ion-no-padding">
        <ion-text
          color="medium"
          text-small
          font-bold
          class="ion-text-uppercase label"
          >reason</ion-text
        >
        <br />
        <ion-text color="medium" text-medium="" class="ion-text-capitalize">{{
          invoiceRejectedObj?.comment
        }}</ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-template>

<ng-template #OnHold_Reject>
  <ion-grid>
    <ion-row [ngClass]="{ 'add-class': selectOrder?.status === 'HOLD' }">
      <ion-col size="12" class="ion-no-padding">
        <ion-text
          color="medium"
          text-small
          font-bold
          class="ion-text-uppercase label"
          >reason</ion-text
        >
        <br />
        <ion-text color="medium" text-medium="" class="ion-text-capitalize">{{
          selectOrder?.rejectionReason
        }}</ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-template>

<!--template Address-->
<ng-template #received_at>
  <ion-grid>
    <ion-row
      class="add-class"
      [ngClass]="{
        'add-class':
          selectOrder?.payment?.orderPaymentStatus != 'INVOICE_PENDING'
      }"
    >
      <ion-col size="12">
        <ion-text color="medium" text-small font-bold class="ion-text-uppercase"
          >received at</ion-text
        >
      </ion-col>
      <ion-col size="12">
        <ion-text color="medium" text-regular="" class="ion-text-uppercase">{{
          selectOrder?.toLocation?.name
        }}</ion-text>
        <br />
        <ion-text
          color="medium"
          text-regular=""
          class="ion-text-capitalize address-box line-3"
          [pTooltip]="selectOrder?.toLocation?.addressInfo | address"
          tooltipStyleClass="tooltip-bg-white"
          >{{ selectOrder?.toLocation?.addressInfo | address }}</ion-text
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-template>
